export default {
  setPermission (state, payload) {
    state.permissions = []
    state.permissions = payload
  },

  setAllPermission (state, payload) {
    // state.permissions = []
    state.all_permission = payload
  },

  addPermission (state, payload) {
    // eslint-disable-next-line no-unused-vars
    var index = state.all_permission.map(function (item) {
      if (item.id === payload.data.parent_id) {
        return item.children.push(payload.data)
      }
      return item
    })
  },

  addGrpPermission (state, payload) {
    var data = payload.data
    data.children = []
    state.all_permission.push(data)
  }
}



// WEBPACK FOOTER //
// ./src/store/module/group-permission/mutations.js